module.exports = __webpack_public_path__ + "3c4d647d7e56784d2e1e2f0966ee672d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/dive-tank.png
// module id = 2834
// module chunks = 0